import { StoreMailCard as SharedStoreMailCard, type StoreMailActions } from '@avrahami/ui';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { keys, storeMailQuery, tenantApi, useStoreTimeZone } from '../api/tenant';
import { he } from '../i18n/he';
import { errorMessage, mergeErrors, parseWith } from '../lib/forms';

const WORDS = { ...he.mail, cancel: he.common.cancel };
const ACTIONS: StoreMailActions = {
  connect: tenantApi.connectStoreMail,
  disconnect: tenantApi.disconnectStoreMail,
  sendTest: tenantApi.testStoreMail,
};
const CHECKS = { parseWith, mergeErrors };

/**
 * The store's own Gmail account (adr/0027), a resource of its own beside the settings form. The
 * card itself is shared with the platform admin.
 */
export function StoreMailCard({ canWrite }: { canWrite: boolean }) {
  const queryClient = useQueryClient();
  const mail = useQuery(storeMailQuery());
  const timeZone = useStoreTimeZone();
  return (
    <SharedStoreMailCard
      mail={mail.data}
      loadError={mail.error}
      canWrite={canWrite}
      timeZone={timeZone}
      words={WORDS}
      actions={ACTIONS}
      errorMessage={errorMessage}
      checks={CHECKS}
      onChange={(updated) => {
        queryClient.setQueryData(keys.storeMail(), updated);
      }}
    />
  );
}
